import { CopyCommand } from "./CopyCommand";

const NAV_LINKS = [
    { label: "how it works", href: "#how-it-works" },
    { label: "setup", href: "#setup" },
    { label: "features", href: "#features" },
    { label: "faq", href: "#faq" },
];

const Navbar = () => (
    <header
        data-testid="navbar"
        className="sticky top-0 z-50 border-b border-[#262626] bg-[#050505]/85 backdrop-blur-md"
    >
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
            <a href="#top" data-testid="nav-logo" className="flex items-center gap-2">
                <span className="inline-block h-3 w-3 bg-green-400" />
                <span className="font-mono text-sm font-semibold tracking-tight text-neutral-100">
                    remembered<span className="text-green-400">.sh</span>
                </span>
            </a>
            <nav className="hidden items-center gap-6 md:flex" data-testid="nav-links">
                {NAV_LINKS.map((link) => (
                    <a
                        key={link.href}
                        href={link.href}
                        data-testid={`nav-link-${link.label.replace(/\s+/g, "-")}`}
                        className="font-mono text-xs text-neutral-500 transition-colors duration-200 hover:text-green-400"
                    >
                        {link.label}
                    </a>
                ))}
            </nav>
            <CopyCommand compact testid="nav-copy-install-button" />
        </div>
    </header>
);

export default Navbar;
